import React, { useEffect, useState } from "react";
import SignUpLayout from "./signUpLayout/SignUpLayout";
import GettingStarted from "./gettingStarted/GettingStarted";
import EmailOtpVerification from "./otpVerification/EmailOtpVerification";
import Individual from "../../components/individual/Individual";
import RegistrationSuccess from "./registrationSuccess/RegistrationSuccess";
import WelcomeScreen from "./welcomeScreen/WelcomeScreen";
import ResidentialInformation from "./residentialInformation/ResidentialInformation";
import { getData } from "../../../apis/apiMethods";
import { apiEndpoints } from "../../../apis/apiEndpoints";
import { appInsights } from "../../../components/AppInsight/AppInsight";
import { useParams, useHistory } from "react-router-dom";
import PhoneOtpVerification from "./otpVerification/PhoneOtpVerification";

function SignUp() {
  const [currentStep, setCurrentStep] = useState(0);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [aggregatorInfo, setAggregatorInfo] = useState<any>(null);
  const [isValidatingAggregator, setIsValidatingAggregator] = useState(false);
  const { partnerName } = useParams();

  const history = useHistory();

  const handleNextStep = () => {
    setCurrentStep((prev) => prev + 1);
  };

  async function validateAggregator(shortName: string) {
    setIsValidatingAggregator(true);

    try {
      const response = await getData(
        `${apiEndpoints.validateAggregator}?shortName=${shortName}`,
      );

      if (response.status) {
        setAggregatorInfo(response.data);
      } else {
        setIsValidatingAggregator(false);
        history.push(`/${partnerName}/page-not-found`);
      }
    } catch (error) {
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "Web Onboarding - (GettingStarted.tsx)",
        },
      });
      history.push(`/${partnerName}/page-not-found`);
    } finally {
      setIsValidatingAggregator(false);
    }
  }

  useEffect(() => {
    validateAggregator(partnerName);
  }, [partnerName]);

  return (
    <SignUpLayout>
      {currentStep === 0 && (
        <GettingStarted
          onNextStep={handleNextStep}
          error={error}
          setError={setError}
          aggregatorInfo={aggregatorInfo}
          isValidatingAggregator={isValidatingAggregator}
        />
      )}

      {currentStep === 1 && (
        <EmailOtpVerification
          onNextStep={handleNextStep}
          setCurrentStep={setCurrentStep}
          setError={setError}
          error={error}
          setSuccess={setSuccess}
          aggregatorInfo={aggregatorInfo}
          success={success}
        />
      )}
      {currentStep === 2 && (
        <PhoneOtpVerification
          onNextStep={handleNextStep}
          setCurrentStep={setCurrentStep}
          setError={setError}
          error={error}
          setSuccess={setSuccess}
          aggregatorInfo={aggregatorInfo}
          success={success}
        />
      )}

      {/*{currentStep === 2 && <BorrowerType setCurrentStep={setCurrentStep} />}*/}

      {/*{currentStep === 3 && (*/}
      {/*  <Business*/}
      {/*    error={error}*/}
      {/*    setError={setError}*/}
      {/*    setSuccess={setSuccess}*/}
      {/*    success={success}*/}
      {/*    setCurrentStep={setCurrentStep}*/}
      {/*  />*/}
      {/*)}*/}

      {currentStep === 3 && (
        <Individual
          error={error}
          setError={setError}
          setSuccess={setSuccess}
          success={success}
          setCurrentStep={setCurrentStep}
          aggregatorInfo={aggregatorInfo}
        />
      )}

      {currentStep === 4 && <WelcomeScreen setCurrentStep={setCurrentStep} />}

      {currentStep === 5 && (
        <ResidentialInformation
          error={error}
          setError={setError}
          setCurrentStep={setCurrentStep}
          isOnboarding={true}
        />
      )}

      {currentStep === 6 && (
        <RegistrationSuccess
          error={error}
          setError={setError}
          setSuccess={setSuccess}
          success={success}
        />
      )}
    </SignUpLayout>
  );
}

export default SignUp;
